module.exports = __webpack_public_path__ + "img/about-fosun-zhTc.3e4cda95.png";